export const team_text =
  "Hanami37, un groupe d'artistes japonais basés en Touraine";

export const team_sub_text =
  "qui exposent leurs créations faites-mains dans des salons dédiés à celles-ci.";

export const footerText = "Hanami37";

export const team_instagram_url = "https://www.instagram.com/hanami.37/";

export const redirect_url_after_updating_product =
  "https://ohanamimart-37000.web.app/admin/";
